// DS2 Card: a white box with a line around the children, 8px apart - a heading (a Title), a picture, a call to
// action (a Button) and the rest. accent: the line dark on every side, for the one card that
// matters most on the screen. background: white (default), subtle or muted. shadow: a soft shadow. onClick: a pointer
// and a hover background.
import cx from "classnames";
import type { HTMLAttributes, Ref } from "react";
import styles from "./Card.module.css";

export type CardProps = Omit<HTMLAttributes<HTMLDivElement>, "title"> & {
  accent?: boolean;
  background?: "white" | "subtle" | "muted";
  shadow?: boolean;
  ref?: Ref<HTMLDivElement>;
};

export function Card({ accent, background = "white", shadow, className, onClick, children, ...props }: CardProps) {
  return (
    <div
      className={cx(
        styles.card,
        accent && styles.accent,
        background !== "white" && styles[background],
        shadow && styles.shadow,
        onClick && styles.clickable,
        className,
      )}
      onClick={onClick}
      {...props}
    >
      <div className={styles.body}>{children}</div>
    </div>
  );
}

export default Card;
